import ManagedEquipement from "./ManagedEquipements-container";

export default ManagedEquipement;